import { render, staticRenderFns } from "./EditStockModal.vue?vue&type=template&id=65c832b5&scoped=true&"
import script from "./EditStockModal.vue?vue&type=script&lang=js&"
export * from "./EditStockModal.vue?vue&type=script&lang=js&"
import style0 from "./EditStockModal.vue?vue&type=style&index=0&id=65c832b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c832b5",
  null
  
)

export default component.exports